import src from "IMAGE";
export default { src, width: 190, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADk5OS53d3dePT09LVpaWkJAQEAtRUVFL0ZGRjIWFhYQAC8vLyFqampIYGBgRmJiYkZgYGBAZGRkRl5eXkIiIiIXRL0Rw4GpQwUAAAAASUVORK5CYII="};
